import { Amplify } from 'aws-amplify'
import { fetchAuthSession, signInWithRedirect, signOut as amplifySignOut } from 'aws-amplify/auth'
import { loadConfig } from './config.js'

let configured = false

export async function configureAmplify(): Promise<void> {
  if (configured) return
  const cfg = await loadConfig()
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: cfg.userPoolId,
        userPoolClientId: cfg.userPoolClientId,
        loginWith: {
          oauth: {
            domain: cfg.cognitoDomain,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: [`${window.location.origin}/`],
            redirectSignOut: [`${window.location.origin}/`],
            responseType: 'code',
          },
        },
      },
    },
  })
  configured = true
}

export async function isAuthenticated(): Promise<boolean> {
  try {
    const session = await fetchAuthSession()
    return Boolean(session.tokens?.accessToken)
  } catch {
    return false
  }
}

export async function getAccessToken(): Promise<string | undefined> {
  const session = await fetchAuthSession()
  return session.tokens?.accessToken?.toString()
}

export function signIn(): void {
  void signInWithRedirect({ provider: 'Google' })
}

export async function signOut(): Promise<void> {
  await amplifySignOut()
  window.location.assign('/')
}
